module.exports = __webpack_public_path__ + "img/Philippe-Bourseiller.29d675e0.jpg";